import { all } from 'redux-saga/effects'
import watchActivitySaga from "./watchActivity";
import sessionIsAliveSaga from './isAlive';

export default function* clientUserSaga() {
    yield all([
        watchActivitySaga(),
        sessionIsAliveSaga()
    ])
}